const translations = {
  intl: {
    sv: {
      rewind: 'Spola tillbaka 10 sekunder',
      exitFullscreen: 'Stäng helskärm',
      captionsStyles: {
        backgroundColor: 'Bakgrundsfärg',
        backgroundOpacity: 'Bakgrundens opacitet',
        fontColor: 'Teckenfärg',
        fontOpacity: 'Tecknens opacitet',
        fontSize: 'Teckenstorlek',
        fontFamily: 'Teckensnittsfamilj',
        edgeStyle: 'Stil för teckenkant',
        raised: 'Upphöjd',
        windowColor: 'Fönsterfärg',
        windowOpacity: 'Fönstrets opacitet',
      },
    },
  },
}

export default translations
